import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerMemberList = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [keyword, setKeyword] = useState('');
  const [members, setMembers] = useState([]);

  const fetchData = async (searchKeyword = '') => {
    try {
      const res = await axios.get(
        `/api/seller/member/list-data?keyword=${encodeURIComponent(searchKeyword)}`,
        {
          withCredentials: true,
        }
      );

      if (res.data?.ok) {
        setShopName(res.data.shop_name || '');
        setMembers(res.data.members || []);
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;

      if (redirect) {
        window.location.href = redirect;
        return;
      }

      alert(err?.response?.data?.error || '회원 정보를 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData(keyword);
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <h2 style={styles.title}>회원관리</h2>

        <form onSubmit={handleSearch} style={styles.searchWrap}>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="아이디 / 닉네임 / 전화번호"
            style={styles.input}
          />

          <button type="submit" style={styles.searchButton}>
            검색
          </button>
        </form>

        <table style={styles.table}>
          <thead>
            <tr>
              <th>아이디</th>
              <th>닉네임</th>
              <th>주문수</th>
              <th>구매금액</th>
              <th>최근주문</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {members.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.nickname}</td>
                <td>{row.order_count}</td>
                <td>{Number(row.total_amount).toLocaleString()}원</td>
                <td>{row.last_order_date || '-'}</td>

                <td>
                  <button
                    style={styles.detailButton}
                    onClick={() =>
                      (window.location.href = `/seller/member/detail?id=${row.id}`)
                    }
                  >
                    상세보기
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loadingWrap: {
    minHeight: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    padding: '0px',
    maxWidth: '1200px',
  },

  title: {
    marginTop: '20px',
    marginBottom: '20px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },

  searchWrap: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },

  input: {
    flex: 1,
    padding: '10px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
  },

  searchButton: {
    padding: '10px 20px',
    background: '#222',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },

  detailButton: {
    background: '#222',
    color: '#fff',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

export default SellerMemberList;